
import { 
    CREATE_ROLE,
    CREATE_ROLE_SUCCESS,
    CREATE_ROLE_FAIL, 
    CREATE_ROLE_RESET,
} from "../actions/createRoleAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const createRoleReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_ROLE:
            return {
                ...state,
                apiState: "loading",
            };
        case CREATE_ROLE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case CREATE_ROLE_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case CREATE_ROLE_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default createRoleReducer;
